import Box from '@mui/material/Box';

import useStyles from './styles';

export const ReminderStatus = ({ color = 'empty' }) => {
  const styles = useStyles();

  return <Box sx={styles.wrapper(color)} />;
};
